module.exports = "<button class=\"button-link\" ng-click=\"$ctrl.showPaycellInfo()\" translate>\n  common.paycellInfo\n\n</button>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/paycell-info-link/paycell-info-link.html
// module id = 297
// module chunks = 0